export const themeStorageKey = 'settings-theme-key';
export function normalizeTheme(value) {
  return ['light', 'dark', 'system'].includes(value) ? value : 'light';
}
export function resolveTheme(preference, prefersDark) {
  const value = normalizeTheme(preference);
  return value === 'system' ? (prefersDark ? 'dark' : 'light') : value;
}
export function decodeTheme(raw, now = Date.now()) {
  try {
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return 'light';
    if (
      data.expires_at !== null &&
      (typeof data.expires_at !== 'number' ||
        !Number.isFinite(data.expires_at) ||
        data.expires_at < now)
    )
      return 'light';
    return normalizeTheme(data.value);
  } catch {
    return 'light';
  }
}
export function readTheme(storage, now = Date.now()) {
  try {
    return decodeTheme(storage.getItem(themeStorageKey), now);
  } catch {
    return 'light';
  }
}
